import UploadInTable from './upload-in-table'

export default UploadInTable;



// WEBPACK FOOTER //
// ./src/views/my-components/upload-in-table/index.js